'use client';
import { Post } from '@/actions/dtos/blog';
import { formatDate } from '@/utils/formatDate';
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

type PostCardProps = {
  post: Post;
  size?: 'small' | 'large';
};

const PostCard = ({ post, size = 'large' }: PostCardProps) => {
  const cardClass = size === 'small' ? 'max-w-xs max-md:w-2xs' : 'max-w-sm max-md:w-2xs';

  return (
    <Link href={`/blog/${post.slug}`} className={`card-hover-effect card border bg-base-200 ${cardClass}`}>
      <div className="flex flex-col">
        {(post.thumbnailUrl || post.imageUrl) && (
          <Image
            src={post.thumbnailUrl ?? post.imageUrl ?? 'kein bild'}
            alt="img"
            width={1880}
            height={1100}
            quality={100}
            className={`w-full rounded-t-2xl object-cover ${size === 'small' ? 'h-40' : 'h-48 max-md:h-40'}`}
          />
        )}
        <div
          className="space-y-2 p-4
        "
        >
          <div className="flex w-full justify-between space-x-2">
            <p className="w-fit text-sm text-primary">{post.category}</p>
            <p className="w-fit text-end font-light">{formatDate(post.date_created)}</p>
          </div>
          <div className="space-y-2">
            <p className="font-medium">{post.title}</p>
            <p className="line-clamp-6">{post.summary}</p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PostCard;
